import React, { useEffect, useState } from 'react';
import { authFetch, API } from '../api';

// Settings → Packing → "New packers" (Fernando 21.10, teaching Shaw: "if a new person is packing an order for the
// first 5 times that has more than 1 the same item then there will be a popup … They can't continue before they
// acknowledge"). Backend: pp_guided._beginner_multi_qty (app_settings 'pp_beginner'), asked at every note scan.

export default function BeginnerCard() {
  const [n, setN] = useState<number | null>(null);
  const [sp, setSp] = useState<number>(10);
  const [nt, setNt] = useState<number>(10);
  const [da, setDa] = useState<number>(3);
  const [dirty, setDirty] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    authFetch(`${API}/pp2/settings/beginner`).then(r => r.ok ? r.json() : null)
      .then(d => { if (d) { setN(d.settings.multi_qty_intro); setSp(d.settings.specials_tip ?? 10); setNt(d.settings.note_tip ?? 10); setDa(d.settings.specials_dismiss_after ?? 3); } }).catch(() => {});
  }, []);
  if (n === null) return null;

  const save = async () => {
    const r = await authFetch(`${API}/pp2/settings/beginner`, { method: 'PUT', body: JSON.stringify({ multi_qty_intro: n, specials_tip: sp, note_tip: nt, specials_dismiss_after: da }) });
    const d = await r.json().catch(() => ({}));
    if (!r.ok) { setMsg(d.detail || 'Could not save'); return; }
    setN(d.settings.multi_qty_intro); setSp(d.settings.specials_tip); setNt(d.settings.note_tip); setDa(d.settings.specials_dismiss_after); setDirty(false); setMsg('✓ Saved'); setTimeout(() => setMsg(''), 2500);
  };

  return (
    <div className="bg-[#1a1d27] rounded-xl border border-gray-800 px-5 py-4">
      <div className="text-white text-sm font-medium">New packers</div>
      <div className="text-gray-500 text-xs mt-0.5 mb-3">
        At a P&P station, an order that needs 2 or more of the same item first shows a full screen "More than one piece —
        scan each piece on its own", which the packer has to confirm before scanning. Counted per person from what they
        have packed; 0 = never.
      </div>
      <div className="flex flex-wrap items-center gap-2 text-sm text-gray-300">
        Show it for a person's first
        <input value={String(n)} onChange={e => { setN(parseInt(e.target.value.replace(/\D/g, ''), 10) || 0); setDirty(true); }}
          className="bg-[#0f1117] border border-gray-700 text-white rounded px-2 py-1 text-sm keep-width w-16 text-center" />
        orders with 2+ of one item (0–50)
      </div>
      <div className="flex flex-wrap items-center gap-2 text-sm text-gray-300 mt-2">
        "Ä and Ö are right here at the station" — for a person's first
        <input value={String(sp)} onChange={e => { setSp(parseInt(e.target.value.replace(/\D/g, ''), 10) || 0); setDirty(true); }}
          className="bg-[#0f1117] border border-gray-700 text-white rounded px-2 py-1 text-sm keep-width w-16 text-center" />
        orders with an Ä / Ö line (0 = never)
      </div>
      <div className="flex flex-wrap items-center gap-2 text-sm text-gray-300 mt-2">
        …"Don't remind me anymore" is offered after they have seen it
        <input value={String(da)} onChange={e => { setDa(parseInt(e.target.value.replace(/\D/g, ''), 10) || 0); setDirty(true); }}
          className="bg-[#0f1117] border border-gray-700 text-white rounded px-2 py-1 text-sm keep-width w-16 text-center" />
        times, and never on their first P&P day
      </div>
      <div className="flex flex-wrap items-center gap-2 text-sm text-gray-300 mt-2">
        "The delivery note is in the parcel" — ticked before the label scan, a person's first
        <input value={String(nt)} onChange={e => { setNt(parseInt(e.target.value.replace(/\D/g, ''), 10) || 0); setDirty(true); }}
          className="bg-[#0f1117] border border-gray-700 text-white rounded px-2 py-1 text-sm keep-width w-16 text-center" />
        orders (0 = never)
        <button onClick={save} disabled={!dirty} className="ml-2 px-3 py-1.5 rounded bg-blue-600 hover:bg-blue-500 text-white text-sm disabled:opacity-40">Save</button>
        {msg && <span className="text-sm text-green-400">{msg}</span>}
      </div>
    </div>
  );
}
